import { observer } from "mobx-react-lite";
import { Form as FinalForm, Field } from "react-final-form";
import {
  isRequired,
  combineValidators,
  composeValidators,
  isNumeric,
  hasLengthBetween,
  matchesField,
} from "revalidate";
import React, { useContext } from "react";
// reactstrap components
import { Alert, Button, FormGroup, Form, Col, Row } from "reactstrap";
import { FORM_ERROR } from "final-form";
import TextInput from "../common/TextInput";
import { RootStoreContext } from "../../app/stores/rootStore";
import { ISetPinFormValues } from "../../app/models/offline";
import LogoCompany from "../common/LogoCompany";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

const validate = combineValidators({
  pin: composeValidators(isRequired, isNumeric, hasLengthBetween(4, 6))("pin"),
  confirmPin: matchesField("pin", "")({ message: "I PIN non corrispondono" }),
});

export const OfflineInitialConfForm = () => {
  const rootStore = useContext(RootStoreContext);
  const { isOnline } = rootStore.commonStore;
  const { saveNativeAppConfToDb } = rootStore.offlineStore;
  const [t] = useTranslation(["nativeapp", "translation"], translationHookOptions);

  return (
    <div className="form-wrapper  mt-0">
      <div>
        <LogoCompany className="loginLogo" />
      </div>
      <h4 className="mb-3">{t("navbar_dropdown_offline_mode")}</h4>
      <h6>
        {t("offline_initial_conf_form_text")}
      </h6>
      <FinalForm
        initialValues={{
          pin: "",
          confirmPin: "",
        }}
        onSubmit={(values: ISetPinFormValues) => {
          if (values.pin === values.confirmPin) {
            saveNativeAppConfToDb(parseInt(values.pin)).catch((error) => ({
              [FORM_ERROR]: error,
            }));
          }
        }}
        validate={validate}
        render={({
          handleSubmit,
          submitting,
          submitError,
          invalid,
          pristine,
          dirtySinceLastSubmit,
        }) => (
          <Form onSubmit={handleSubmit} role="form">
            <FormGroup className="form-group input-group-lg">
              <Field
                className="form-control"
                name="pin"
                component={TextInput}
                placeholder="PIN (4-6 cifre)"
                type="password"
                autoComplete="off"
              />
            </FormGroup>
            <FormGroup className="form-group input-group-lg">
              <Field
                className="form-control"
                name="confirmPin"
                component={TextInput}
                placeholder="Ripeti PIN"
                type="password"
                autoComplete="off"
              />
            </FormGroup>
            {submitError && !dirtySinceLastSubmit && (
              <Alert color="danger">{t("pin_error")}</Alert>
            )}
            <Row>
              <Col>
                <div className="text-center">
                  <Button
                    disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                    className="btn loginButton btn-block btn-lg"
                    color="dark"
                    type="submit"
                  >
                    {t("save_pin")}
                  </Button>
                </div>
              </Col>
              <Col>
                <div className="text-center">
                  <Button
                    className="btn loginButton btn-block btn-lg"
                    color="dark"
                    type="submit"
                    onClick={() => saveNativeAppConfToDb()}
                  >
                    {t("disable_pin")}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        )}
      />
      {isOnline && (
        <div className="mt-5">
          <div className="text-center text-muted mb-0">
            <small>{t("login_method_separator", { ns : "translation" })}</small>
          </div>
          <div className="text-center text-muted mb-4">
            <a
              className="btn btn-dark text-white loginButton btn-outline-light btn-sm"
              href="/"
            >
              <u>{t("go_online")}</u>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default observer(OfflineInitialConfForm);
